export default __webpack_public_path__ + "static/media/zone-24.d28fd7cf.svg";